$(function(){
  // Don't reset font when restoring a cart edit session
  if (window.__cnbEditPrefillActive || /[?&]edit_personalisation=1(?:&|$)/.test(String(window.location.search))) {
    return;
  }
  // Bundle list setup has its own font defaults
  if ($('.jsc-bundle-list-setup').length === 0) {
    onLoadSelectFontDefaultOption();
    updateSelectorText();
  }
  //onLoadSelectPosDefaultOption();
})

if (typeof jscClampLeatherTextToMaxlength !== 'function') {
  jscClampLeatherTextToMaxlength = (text, inputEl) => {
    if (text == null || text === '') return text;
    var el = inputEl && inputEl.getAttribute ? inputEl : document.getElementById('leather-text');
    if (!el || !el.getAttribute) return text;
    var max = parseInt(el.getAttribute('maxlength'), 10);
    if (isNaN(max) || max < 1) return text;
    return text.length > max ? text.slice(0, max) : text;
  };
}

onclickPersonalisation  = () =>{
  if ($('#setPersonalise').length > 0) {
    $('.Alt_Product__Slideshow').hide();
    $('.selectedNav').hide();
    $('.jsc-set-img').show();

    setTimeout(function(){
    var tabID = $('.tab-selected').attr('data-prodID');
    var tabIMG = $('.tab-selected').attr('data-img');
    swapTabimg(tabIMG);
    changeFontTypeSet($('#fontType-' + tabID));
    changeFontSizeSet($('#fontSize-' + tabID));
    $('.foil-option').each(function(){
      var $this = $(this);
      var _foilprodID = $this.attr('data-prodID');
      if ($this.hasClass('foil-selected') && _foilprodID == tabID ) {
        lFoilSet($this);
      }
    });
    $('.position-layout-label').each(function(){
      var $this = $(this);
      var _layoutprodID = $this.attr('data-prodID');
      if ($this.hasClass('layout-selected') && _layoutprodID == tabID) {
        lLayoutSet($this);
      }
    });
    }, 100);
  }
}

removePunctuation = (evt) => {
  var $this = $(evt);
  var $textVal = $this.val();
  var $textOverlay = $('#personalisation-text');
  var $fontFamily = $('#fontType').val();
  var $fontSize = $('#fontSize').find(':selected').text();
  
  // Disable special character
  if ($fontFamily == 'Copperplate' && $fontSize == '10mm') {
    var temp = $textVal.replace(/[^-'.&a-zA-Z@#\s]/g, '').replaceAll('*', '').replaceAll('+', '').replaceAll("'", "");
  } else if ($fontFamily == 'Script Sentence' && $fontSize == '6mm'){
    var temp = $textVal.replace(/[^'.&a-zA-Z0-9\s]/g, '').replaceAll('*', '').replaceAll('+', '').replaceAll("'", "").replaceAll('.', '');
  } else {
    var temp = $textVal.replace(/[^'.&a-zA-Z0-9\s]/g, '').replaceAll('*', '').replaceAll('+', '');
  }
  if ($this.attr('id') === 'leather-text') {
    temp = jscClampLeatherTextToMaxlength(temp, $this[0]);
  }
  $this.val(temp);
  $textOverlay.text(temp);
}

lLayout = (evt) => {
  if ($('.jsc-bundle-list-setup').length > 0) return;
  var $this = $(evt);
  var _ltop = $this.attr('data-ltop');
  var _lleft = $this.attr('data-lleft');
  var _isShow = $this.attr('value');
  var _fontType = $('#fontType').val(); console.log(_fontType,'hy');
  var _topTransform = $this.attr('data-topTransform');
  var _leftTransform = $this.attr('data-leftTransform');

  $(".personalisation-text-overlay").attr('style', 'transform: translate('+_leftTransform+','+_topTransform+')');
  $(".personalisation-text-overlay").css( "top", _ltop);
  $(".personalisation-text-overlay").css( "left", _lleft);
  $('.position-layout-label').removeClass('layout-selected');
  $this.addClass('layout-selected');

  $(".showLayout").html(_isShow);
}

lFoil = (evt) => {
  if ($('.jsc-bundle-list-setup').length > 0) return;
  var $this = $(evt);
  var _lfoil = $this.data('foil');
  var _isShow = $this.data('val');
  var $textPersonalise = $('.personalisation-text');
  var $texture_url = $this.attr('data-texture');
  var $backgroundTexture = "-webkit-linear-gradient(top, transparent, transparent), url('"+ $texture_url +"') center center no-repeat";

  $textPersonalise.css( "color", _lfoil);
  $('.foil-list').children('.foil-option').removeClass('foil-selected');
  $this.addClass('foil-selected');
  $(".showFoil").html(_isShow);

  $textPersonalise.css('background',$backgroundTexture);
  $textPersonalise.css('text-shadow', ' ');
  $textPersonalise.css('opacity', ' ');
  if (_isShow == 'Black') {
    $textPersonalise.css('background', '#000000');
  }
  if (_isShow == 'White') {
    $textPersonalise.css('background', '#FFFFFF');
  }
  if (_isShow == 'Blind Deboss') {
    var colorvar = $('.jsc-col-var input:checked').val();
    var hasdebosscol = false;

    $('.deboss-color-data').each(function(){
      var varcol = $(this).val();
      var coldeboss = $(this).attr('data-coldeboss');
      if (colorvar == varcol) {
        $textPersonalise.css('background', coldeboss);
        hasdebosscol = true;
      }
    });

    if (hasdebosscol == false) {
      $textPersonalise.css('background', '#666666');
    }
    $textPersonalise.css('color', 'transparent');
    $textPersonalise.css('opacity', '1');
  }
}

$('#leather-text').on('input change compositionend', function (evt) {
  var _ltext = $('#leather-text').val();
  var $fontFamily = $('.font-type-container').find('.jsc-dropdown-options .jsc-option[selected="selected"]').attr('data-font-name');
  var $fontSize = $('.font-type-container').find('.jsc-dropdown-options .jsc-option[selected="selected"]').attr('data-size');
  $('#input-text-error').hide();

  if ($fontFamily == 'Copperplate' && $fontSize == '10mm') {
    var temp = _ltext.replace(/[^-'.&a-zA-Z@#\s]/g, '').replaceAll('*', '').replaceAll('+', '').replaceAll("'", "").replace(/[0-9]/g, '');
  } else if ($fontFamily == 'Script Sentence' && $fontSize == '6mm'){
    var temp = _ltext.replace(/[^'.&a-zA-Z0-9\s]/g, '').replaceAll('*', '').replaceAll('+', '').replaceAll("'", "").replaceAll('.', '');
  } else {
    var temp = _ltext.replace(/[^'.&a-zA-Z0-9\s]/g, '').replaceAll('*', '').replaceAll('+', '');
  }

  temp = jscClampLeatherTextToMaxlength(temp, this);
  $('#leather-text').val(temp);
  $(".personalisation-text").text(temp);
  var $charNum = $('.charNum');
  var $max = this.getAttribute("maxlength");
  var $len = temp.length;
  $charNum.text($len + '/' + $max);
});

$("#leather-text").bind('paste', function (evt) {
  setTimeout(function () {
    var $fontFamily = $('#fontType').val();
    var $fontSize = $('#fontSize').find(':selected').text();
    var _ltext = $("#leather-text").val();
    //console.log(_ltext);
    //console.log(evt);
  // hide input text error message
  $("#input-text-error").hide();

  // Disable special character
  var regex = new RegExp("['-.&a-zA-Z0-9]+$");
  // var temp = _ltext.replace(/[^'.&a-zA-Z0-9\s]/g, "").replaceAll("*", "").replaceAll("+", "");
  if ($fontFamily == 'Copperplate' && $fontSize == '10mm') {
    var temp = _ltext.replace(/[^-'.&a-zA-Z@#\s]/g, "").replaceAll("*", "").replaceAll("+", "").replaceAll("'", "");
  } else if ($fontFamily == 'Script Sentence' && $fontSize == '6mm'){
    var temp = _ltext.replace(/[^'.&a-zA-Z0-9\s]/g, "").replaceAll("*", "").replaceAll("+", "").replaceAll("'", "").replaceAll('.', '');
  } else {
    var temp = _ltext.replace(/[^'.&a-zA-Z0-9\s]/g, "").replaceAll("*", "").replaceAll("+", "");
  }

  var leatherPasteEl = document.getElementById('leather-text');
  temp = jscClampLeatherTextToMaxlength(temp, leatherPasteEl);
  $("#leather-text").val(temp);
  $(".personalisation-text").text(temp);
  // To show how many character (s)left
  var $charNum = $(".charNum");
  var $max = $("#leather-text").attr("maxlength");
  var $len = temp.length;
  var $overlayText = $(".personalisation-text");
  var $char = 0;
  $char = $max - $len;
  $charNum.text($len + '/' + $max);
    }, 500 );



});
//Function for new set product Personalise

onKeyup = (evt) =>{
  //console.log(evt)
  var _ltext = $(evt).val();
  var _prodID = $(evt).attr('data-prodID');
  var $fontFamily = $('#fontType').val();
  var $fontSize = $('#fontSize').find(':selected').text();

  // Disable special character
  var regex = new RegExp("['-.&a-zA-Z0-9]+$");
  // var temp = _ltext.replace(/[^'.&a-zA-Z0-9\s]/g, '').replaceAll('*', '').replaceAll('+', '');
  if ($fontFamily == 'Copperplate' && $fontSize == '10mm') {
    var temp = _ltext.replace(/[^-'.&a-zA-Z@#\s]/g, '').replaceAll('*', '').replaceAll('+', '').replaceAll("'", "");
  } else if ($fontFamily == 'Script Sentence' && $fontSize == '6mm'){
    var temp = _ltext.replace(/[^'.&a-zA-Z0-9\s]/g, '').replaceAll('*', '').replaceAll('+', '').replaceAll("'", "").replaceAll('.', '');
  } else {
    var temp = _ltext.replace(/[^'.&a-zA-Z0-9\s]/g, '').replaceAll('*', '').replaceAll('+', '');
  }

  var _setMax = parseInt($(evt).attr('maxlength'), 10);
  if (!isNaN(_setMax) && _setMax >= 1 && temp.length > _setMax) {
    temp = temp.slice(0, _setMax);
  }

  $(evt).val(temp);
  $(".personalisation-text").text(temp);

  // To show how many character (s)left
  var $max = $(evt).attr("maxlength");
  var $len = temp.length;
  var $char = 0;
  $char = $max - $len;
  $('.charNum').each(function(){
    var prodID = $(this).attr('data-prodID');
    if (_prodID == prodID) {
      $(this).text($len + '/' + $max);
    }
  });


}
onPaste = (evt) => {
  console.log('paste')
  var _ltext = $(evt).val();
  var _prodID = $(evt).attr("data-prodID");
  var $fontFamily = $('#fontType').val();
  var $fontSize = $('#fontSize').find(':selected').text();

  // Disable special character
  var regex = new RegExp("['-.&a-zA-Z0-9]+$");
  var temp = _ltext.replace(/[^'.&a-zA-Z0-9\s]/g, "").replaceAll("*", "").replaceAll("+", "");
  if ($fontFamily == 'Copperplate' && $fontSize == '10mm') {
    var temp = _ltext.replace(/[^-'.&a-zA-Z@#\s]/g, "").replaceAll("*", "").replaceAll("+", "").replaceAll("'", "");
  } else if ($fontFamily == 'Script Sentence' && $fontSize == '6mm'){
    var temp = _ltext.replace(/[^'.&a-zA-Z0-9\s]/g, "").replaceAll("*", "").replaceAll("+", "").replaceAll("'", "").replaceAll('.', '');
  } else {
    var temp = _ltext.replace(/[^'.&a-zA-Z0-9\s]/g, "").replaceAll("*", "").replaceAll("+", "");
  }

  var _setPasteMax = parseInt($(evt).attr('maxlength'), 10);
  if (!isNaN(_setPasteMax) && _setPasteMax >= 1 && temp.length > _setPasteMax) {
    temp = temp.slice(0, _setPasteMax);
  }

  $(evt).val(temp);
  $(".personalisation-text").text(temp);

  // To show how many character (s)left
  var $max = $(evt).attr("maxlength");
  var $len = temp.length;
  var $char = 0;
  $char = $max - $len;
  $(".charNum").each(function () {
    var prodID = $(this).attr("data-prodID");
    if (_prodID == prodID) {
      $(this).text($len + '/' + $max);
    }
  });
};
lLayoutSet = (evt) => {
  var $this = $(evt);
  
  var _layoutprodID = $this.attr('data-prodID');
  var text = $('#leather-set-text-' + _layoutprodID).val()
  var _ltop = $this.attr('data-ltop');
  var _lleft = $this.attr('data-lleft');
  var _isShow = $this.attr('value');
  var _fontType = $('#fontType-' + _layoutprodID).val(); console.log(_fontType,'hy',text,_isShow);
  var _topTransform = $this.attr('data-topTransform');
  var _leftTransform = $this.attr('data-leftTransform');

  $(".personalisation-text-overlay").attr('style', 'transform: translate('+_leftTransform+','+_topTransform+')');
  $(".personalisation-text-overlay").css( "top", _ltop);
  $(".personalisation-text-overlay").css( "left", _lleft);

  $('.position-layout-label').each(function(){
    var prodID = $(this).attr('data-prodID');
    if (_layoutprodID == prodID) {
      $(this).removeClass('layout-selected');
    }
  });

  $this.addClass('layout-selected');

  $('.showLayout').each(function(){
    var prodID = $(this).attr('data-prodID');
    if (_layoutprodID == prodID) {
      $(this).html(_isShow);
    }
  });

}

lFoilSet = (evt) => {
  var $this = $(evt);
  var _foilprodID = $this.attr('data-prodID');
  var _lfoil = $this.data('foil');
  var _isShow = $this.data('val');
  var $textPersonalise = $('.personalisation-text');
  var $texture_url = $this.attr('data-texture');
  var $backgroundTexture = "-webkit-linear-gradient(top, transparent, transparent), url('"+ $texture_url +"') center center no-repeat";


  $textPersonalise.css( "color", _lfoil);
  $('.foil-list').each(function(){
    var prodID = $(this).attr('data-prodID');
    if (_foilprodID == prodID) {
      $(this).children('.foil-option').removeClass('foil-selected');
    }
  });

  $('.showFoil').each(function(){
    var prodID = $(this).attr('data-prodID');
    if (_foilprodID == prodID) {
      $(this).html(_isShow);
    }
  });

  $this.addClass('foil-selected');
  $textPersonalise.css('background',$backgroundTexture);
  $textPersonalise.css('text-shadow', ' ');
  $textPersonalise.css('opacity', ' ');
  if (_isShow == 'Black') {
    $textPersonalise.css('background', '#000000');
  }
  if (_isShow == 'White') {
    $textPersonalise.css('background', '#FFFFFF');
  }
  if (_isShow == 'Blind Deboss') {
    var colorvar = $('.jsc-col-var input:checked').val();
    var hasdebosscol = false;

    $('.deboss-color-data').each(function(){
      var varcol = $(this).val();
      var coldeboss = $(this).attr('data-coldeboss');
      if (colorvar == varcol) {
        $textPersonalise.css('background', coldeboss);
        hasdebosscol = true;
      }
    });

    if (hasdebosscol == false) {
      $textPersonalise.css('background', '#666666');
    }
    
    $textPersonalise.css('color', 'transparent');
    $textPersonalise.css('opacity', '1');
  }

  // console.log(_isShow, "_isShow");
}

changeFontTypeSet = (evt) =>{
  var tabID = $('.tab-selected').attr('data-prodID');
  $(evt).each(function(){
  var $this = $(this);
  var fontTypeID = $this.attr('data-prodID');
    
  if (fontTypeID == tabID) {
    var $val = $this.val();
    var $fontLimit = $this.find(':selected').attr('data-character').split(',');
    var $charCount = $('.charNum--' + tabID);
    var $textInput = $('#leather-set-text-' + tabID);
 
    var $textOverlay = $('.personalisation-text');
    var temp = 0;
    var fontTypeID = $this.val();
    // remove overlay class to add new class
    // $textOverlay.removeClass();

    // hide font type error message
    $('#font-type-error').hide();

    // Update font size options
    var $fontSizeSelect = $('#fontSize-' + tabID);
    var $fontSizeSelected = $('#fontSize-' + tabID).find(':selected');
    var $sizeArray = $this.find(':selected').attr('data-size').split(',');
    var $sizeText = $this.find(':selected').attr('data-mm').split(',');
    $fontSizeSelect.children().not('.not-to-remove').remove(); // Remove all options except the one with .not-to-remove class


    for (var i = 0; i < $sizeArray.length; i++) {
      var $appendSize = '<option data-character="'+$fontLimit[i]+'" value="'+$sizeArray[i]+'">'+$sizeText[i]+'</option>'
      $fontSizeSelect.append($appendSize);

      // Update font-size for text overlay
      if (i == 0) {

        if ($(window).width() > 481) {
          $textOverlay.css('font-size',$sizeArray[i]);
        }else {
          var _fontmobcheck = parseInt($sizeArray[i]);
          var _fontmob = _fontmobcheck * 0.7;
          $textOverlay.css('font-size',_fontmob + 'px');
        }
          $textOverlay.addClass('personalisation-text');
      }

      // Trim text according to limit length
      //var $trimText = $textInput.val().substring(0, $fontLimit[i]);
      //$textInput.val($trimText);
      //$textOverlay.text($trimText);

      // calculate and replace the character left value
      temp = $fontLimit[i] - $textInput.val().length;

      if (i == 0) {
      $charCount.attr('data-limit', $fontLimit[i]);
      $charCount.text($textInput.val().length + '/' + $fontLimit[i]);
      $textInput.attr('maxlength', $fontLimit[i]);
      }
    }

    // Update font family for text overlay
    $textOverlay.css('font-family', $val);

    if ($val == 'Goudy Sentence' || $val == 'Script Sentence') {
      $textOverlay.css('text-transform', 'none');
      $('#leather-text').css('text-transform', 'none');
      $textOverlay.css('font-family', $val.replace(' ', ''));
    } else {
      $textOverlay.css('text-transform', 'uppercase');
      $('#leather-text').css('text-transform', 'uppercase');
    }

  }
  });
}

changeFontSizeSet = (evt) =>{
  var tabID = $('.tab-selected').attr('data-prodID');

  $(evt).each(function(){
  var $this = $(this);
  var fontSizeID = $this.attr('data-prodID');

  if (fontSizeID == tabID) {
    var $val = $this.val();
    var $fontFamily = $('#fontType-' + tabID).val();
    var $fontLimit = parseInt($this.find(':selected').attr('data-character'));
    var $charCount = $('.charNum--' + tabID);
    var $textInput = $('#leather-set-text-' + tabID );
    var $textOverlay = $('.personalisation-text');

    // hide font size error message
    $('#font-size-error').hide();

    // Trim text according to limit length
    var $trimText = $textInput.val().substring(0, $fontLimit);
    $textInput.val($trimText);
    $textOverlay.text($trimText);

    // calculate and relpace the character left value
    var temp = 0;
    temp = $fontLimit - $textInput.val().length;
    // $charCount.attr('data-limit', $fontLimit);
    $charCount.text($textInput.val().length + '/' + $fontLimit);
    $textInput.attr('maxlength', $fontLimit);
    if ($fontFamily == null) {
      $fontFamily = 'Univers';
    }

    if ($(window).width() > 481) {
      $textOverlay.css('font-size',$val);
    }else {
      var _fontmobcheck = parseInt($val);
      var _fontmob = _fontmobcheck * 0.7;
      $textOverlay.css('font-size',_fontmob + 'px');
    }
  }
  });
}

onclicksetTab = (evt) => {

  var $this = $(evt);
  var _prodID = $this.attr('data-prodID');
  $('.jsc-btnTab').removeClass('tab-selected');
  $this.addClass('tab-selected');
  var text = $("#leather-set-text-" + _prodID).val();
  console.log(text)
  $('.tab-content').each(function(){
    var $this = $(this);
    var _contprodID = $this.attr('data-prodID');
    if ( _contprodID == _prodID ) {
      $this.addClass('tab-content-selected');
    }else {
      $this.removeClass('tab-content-selected');
    }
  });

  setTimeout(function(){
    changeFontTypeSet($('#fontType-' + _prodID));
    changeFontSizeSet($('#fontSize-' + _prodID));
    $('.foil-option').each(function(){
      var $this = $(this);
      var _foilprodID = $this.attr('data-prodID');
      if ($this.hasClass('foil-selected') && _foilprodID == _prodID ) {
        lFoilSet($this);
      }
    });
    $('.position-layout-label').each(function(){
      var $this = $(this);
      var _layoutprodID = $this.attr('data-prodID');
      if ($this.hasClass('layout-selected') && _layoutprodID == _prodID) {
        lLayoutSet($this);
      }
    });
  },300);

}

swapTabimg = (scr) => {
  $('.jsc-set-img').find('.Image--fadeIn').attr('srcset',scr);
}

function onpasteText() {
  var result = "";
  var clipboard_data = event.clipboardData || window.clipboardData;
  var pasted_text = clipboard_data.getData("text");

  var gift_input = document.getElementById("cart-note");
  var max_len = parseInt(gift_input.getAttribute("maxlength"));

  //disabled paste element
  event.preventDefault();

  // add enter(\n) after 30 characters
  while (pasted_text.length > 0) {
    var checkSpace = pasted_text.charAt(25);
    var subStri = 25;
    if (checkSpace != " " && checkSpace != "" && checkSpace != null) {
      for (let j = 25; j >= 0; j--) {
        if (pasted_text.charAt(j) == " ") {
          subStri = j;
          j = -1;
        }
      }
    }

    result += pasted_text.substring(0, subStri) + "\n";
    pasted_text = pasted_text.substring(subStri);
  }

  // set the gift message value with enter
  var char_count = 0;
  var result_len = result.length;
  var final_result = result.replace(
    /[^'[-\]\\`~\-=+_!@#$%^(){}:;"″""''’′<>,?/*.&a-zA-Z0-9\s]/g,
    ""
  );

  gift_input.value = final_result.substring(0, max_len);
  var final_result_len = gift_input.value.length;

  char_count = max_len - final_result_len;
  $("#charRemainNo").text(char_count);
}

// start: personalise form custom selector
toggleOptionDropdown = (e) => {
  var $selector = $(e).parents('.jsc-custom-selector');
  $selector.toggleClass('active');
}

updateSelectorText = () => {
  var $selectors = $('.jsc-custom-selector');
  $selectors.each(function() {
    var selectedOptText = $(this).find('.jsc-dropdown-options .jsc-option[selected="selected"]').text();
    var $selectorText = $(this).find('.jsc-selected-text');
    $selectorText.text(selectedOptText);
  })
}

updateTextOverlay = (opt) => {
  // Bundle list PDP owns its own per-card overlays — do not touch global .personalisation-text
  if ($('.jsc-bundle-list-setup').length > 0) return;

  // selected option details
  removeDigitsPersonalisation(opt);
  var fontNameAttr = $(opt).attr('data-font-name');
  // Position options call changeSelectedOption too but have no font attrs — skip overlay font update
  if (!fontNameAttr) {
    return;
  }
  var fontName = fontNameAttr.replace(" ", "");
  var fontSize = $(opt).attr('data-font-size');
  var charLimit = parseInt($(opt).attr('data-character'));
  var fontSizemob = $(opt).attr('data-font-size-mob');
  var textposleft = $(opt).attr('data-left');
  var textposleftmob = $(opt).attr('data-left-mob');

  var $textOverlay, $textInput, $charCount;
  if($('.notebook-tab.personalize-tab').length > 0) {
    $textOverlay = $('#personalize-textoverlay-span');
    $textInput = $('#personalize-text-input');
    $charCount = $('#charCount');
  }
  else {
    $textOverlay = $('.personalisation-text');
    $textInput = $("#leather-text");
    $charCount = $(".charNum");
  }
  
  // set text overlay styling
  $textOverlay.css('font-family', fontName);
  if($(window).width() > 481) {
    $textOverlay.css('font-size', fontSize);
  }
  else {
    var deskfontsize = parseInt(String(fontSize || '').replaceAll('px', ''), 10) || 0;
    var mobileFontSize = deskfontsize * 0.7;
    $textOverlay.css('font-size', mobileFontSize);
    if (fontSizemob) {
      $textOverlay.css('font-size', fontSizemob);
    }
  }
  if(fontName === "GoudySentence" || fontName === "ScriptSentence" || fontName === "Plantin") {
    $textOverlay.css('text-transform', 'none');
    $textInput.css('text-transform', 'none');
  }
  else {
    $textOverlay.css('text-transform', 'uppercase');
    $textInput.css('text-transform', 'uppercase');
  }

  if (textposleft) {
    $textOverlay.parent().css('left', textposleft);
  }
  if($(window).width() <= 481) {
    console.log('asdasdasd',textposleftmob);
    if (textposleftmob) {
      $textOverlay.parent().css('left', textposleftmob);
    }
  }

  // trim text input
  var $trimText = $textInput.val().substring(0, charLimit);
  $textInput.val($trimText);
  $textOverlay.text($trimText);

  // update character count
  $charCount.text($textInput.val().length + '/' + charLimit);
  $textInput.attr("maxlength", charLimit);
}

changeSelectedOption = (e) => {
  var $otherOptions = $(e).siblings('.jsc-option');
  var $selector = $(e).parents('.jsc-custom-selector');

  // update selector
  $(e).attr('selected', 'selected');
  $otherOptions.removeAttr('selected');
  updateSelectorText();
  $selector.removeClass('active');  

  updateTextOverlay($(e));
}

removeDigitsPersonalisation = (opt) => {
  var fontNameAttr = $(opt).attr('data-font-name');
  if (!fontNameAttr) return;
  var $fontFamily = fontNameAttr.replace(" ", "");
  var $fontSize = $(opt).attr('data-size');
  console.log('change option to',$fontFamily,$fontSize);
  if ($fontFamily == 'Copperplate' && $fontSize == '10mm') {
    var _ltext = $('.jsc-personalize-text-input').val();
    var temp = _ltext.replace(/[^-'.&a-zA-Z@#\s]/g, '').replaceAll('*', '').replaceAll('+', '').replaceAll("'", "").replace(/[0-9]/g, '');
    
    $('.jsc-personalize-text-input').val(temp);
  }
}

onLoadSelectFontDefaultOption = () => {
  var $fontSelector = $('.font-type-container .jsc-custom-selector');
  if($fontSelector.length > 0) {
    var $firstOpt = $($fontSelector).find('.jsc-dropdown-options .jsc-option:first');
    $firstOpt.attr('selected', 'selected');
    updateSelectorText();
    updateTextOverlay($firstOpt);
  }
}
// end: personalise form custom selector